import { MainLayout } from "@/components/MainLayout";
import { ProjectDashboard } from "@/components/projects/ProjectDashboard";
import { SEO } from "@/components/SEO";

export default function ProjectDashboardPage() {
  return (
    <MainLayout>
      <SEO 
        title="Dashboard de Projetos"
        description="Health Check: acompanhe quantos projetos estão ativos, no lucro e em prejuízo com métricas financeiras detalhadas"
        keywords="dashboard projetos, gestão projetos, lucratividade projetos, health check projetos"
      />
      <ProjectDashboard />
    </MainLayout>
  );
}

